const settings = {
  el: document.querySelector<HTMLDivElement>(`#notify`)!
};

export function show(msg: string, autoRemove = false) {
  const { el } = settings;
  el.classList.remove(`faded`);
  el.innerText = msg;

  if (autoRemove) {
    setTimeout(() => {
      if (el.innerText === msg) {
        hide();
      }
    }, 5000);
  }
}

export function hide() {
  const { el } = settings;
  el.classList.add(`faded`);

}

export function toggle() {
  const { el } = settings;
  el.classList.toggle(`faded`);
}

export function init() {
  const { el } = settings;
  el.addEventListener(`click`, toggle);
  hide();

}